import { render, staticRenderFns } from "./NavigationBtnToInformation.vue?vue&type=template&id=33b8a096&"
import script from "./NavigationBtnToInformation.vue?vue&type=script&lang=ts&"
export * from "./NavigationBtnToInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports